import {getStore} from "trim-redux";

export const defaultVariabls = {
    url: "https://rayanita.com/api",
    uploads: "https://rayanita.com/uploads",
    React:"https://p.rayanita.com",
    website: "https://rayanita.com",
    developer: "https://rayanita.com",
};
/*export let defaultVariabls = {
    url: "http://localhost:8000/api",
    uploads: "http://localhost:8000/uploads",
    React:"http://localhost:3000",
    website: "http://127.0.0.1:8000",
    developer: "https://rayanita.com",
    root: "localhost",
}*/


